export default "__VITE_ASSET__AK5SxUFa__"